import { OnDemandStatus } from '@core/types';
import { useTranslation } from 'react-i18next';

const STATUS_CONFIG: Record<OnDemandStatus, { labelKey: string; className: string } | null> = {
    [OnDemandStatus.None]: null,
    [OnDemandStatus.Processing]: { labelKey: 'Content.OnDemand.Status.Processing', className: 'bg-info' },
    [OnDemandStatus.Available]: { labelKey: 'Content.OnDemand.Status.Available', className: 'bg-success btn--success text-btn-color' },
    [OnDemandStatus.Failed]: { labelKey: 'Content.OnDemand.Status.Failed', className: 'bg-warning btn--warning text-btn-color' }
};

export const OnDemandStatusBadge = ({ status }: { status: OnDemandStatus }) => {
    const { t } = useTranslation();
    const config = STATUS_CONFIG[status];

    if (!config) {
        return null;
    }

    return <span className={`rounded-full inline-flex items-center font-medium text-sm px-2 py-0.5 ${config.className}`}>{t(config.labelKey)}</span>;
};
